import { render, staticRenderFns } from "./MyBusiness.vue?vue&type=template&id=25ab1190&scoped=true&"
import script from "./MyBusiness.vue?vue&type=script&lang=js&"
export * from "./MyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./MyBusiness.vue?vue&type=style&index=0&id=25ab1190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab1190",
  null
  
)

export default component.exports